import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { voucherPaymentType } from 'global/Models/voucherModel';

type initialStateType = {
  voucherPaymentType: voucherPaymentType[] | undefined;
};

const initialState: initialStateType = { voucherPaymentType: undefined };

export const voucherSlice = createSlice({
  name: 'voucher',
  initialState,
  reducers: {
    setVoucherPayment: (state, action: PayloadAction<voucherPaymentType[]>) => {
      state.voucherPaymentType = action.payload;
    },
  },
});

export const { setVoucherPayment } = voucherSlice.actions;

export default voucherSlice.reducer;
